import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const getSubcats = (categories, catName) => categories.find(c => c.name === catName)?.subcategories || [];
const getChildren = (categories, catName, subcatName) => {
  const sub = getSubcats(categories, catName).find(s => s.name === subcatName);
  return sub?.children || [];
};

export function CategoryPicker({ categories, value, onChange }) {
  const subcatOpts = getSubcats(categories, value.category);
  const detailOpts = getChildren(categories, value.category, value.subcategory);

  return (
    <div className="space-y-2">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">Category to Apply</p>
      <div className="grid grid-cols-3 gap-2">
        <Select value={value.category || '__none__'} onValueChange={v => onChange({ category: v === '__none__' ? '' : v, subcategory: '', detail: '' })}>
          <SelectTrigger className="text-xs" data-testid="review-category-select"><SelectValue placeholder="Category" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="__none__">None</SelectItem>
            {categories.map(c => <SelectItem key={c.id} value={c.name}>{c.name}</SelectItem>)}
          </SelectContent>
        </Select>
        {subcatOpts.length > 0 && (
          <Select value={value.subcategory || '__none__'} onValueChange={v => onChange({ subcategory: v === '__none__' ? '' : v, detail: '' })}>
            <SelectTrigger className="text-xs" data-testid="review-subcategory-select"><SelectValue placeholder="Subcategory" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="__none__">None</SelectItem>
              {subcatOpts.map(s => <SelectItem key={s.name} value={s.name}>{s.name}</SelectItem>)}
            </SelectContent>
          </Select>
        )}
        {detailOpts.length > 0 && (
          <Select value={value.detail || '__none__'} onValueChange={v => onChange({ detail: v === '__none__' ? '' : v })}>
            <SelectTrigger className="text-xs" data-testid="review-detail-select"><SelectValue placeholder="Detail" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="__none__">None</SelectItem>
              {detailOpts.map(d => <SelectItem key={d} value={d}>{d}</SelectItem>)}
            </SelectContent>
          </Select>
        )}
      </div>
    </div>
  );
}
